export const TAB_TEACHING_NOTES = 'notes';
export const TAB_TEACHING_ANSWERS = 'answers';

export const TAB_OPTIONS = [
  {
    label: 'Teaching Notes',
    value: TAB_TEACHING_NOTES,
  },
  {
    label: 'Answers',
    value: TAB_TEACHING_ANSWERS,
  },
];
